<div [formGroup]="form">
    <app-website-config-form-expansion-panel [title]="'Quick-Actions Widget'" [firstMarginTop]="true">

        <!-- Widget Enabled Toggle -->
        <div class="admin-row no-border-bottom">
            <mat-checkbox formControlName="isEnabled" class="cell">
                Quick-Actions Widget aktivieren
            </mat-checkbox>
            <div class="cell">

                <mat-form-field appearance="outline" class="form-field-width cell">
                    <mat-label>Position auf der Seite</mat-label>
                    <mat-select formControlName="position">
                        <mat-option value="bottom-right">Unten rechts</mat-option>
                        <mat-option value="bottom-left">Unten links</mat-option>
                        <mat-option value="center-right">Mitte rechts</mat-option>
                        <mat-option value="center-left">Mitte links</mat-option>
                        <mat-option value="top-right">Oben rechts</mat-option>
                        <mat-option value="top-left">Oben links</mat-option>
                    </mat-select>
                </mat-form-field>

            </div>
        </div>

        @if (form.get('isEnabled')?.value) {

        <p class="admin-text headline">Verfügbare Aktionen</p>
        <div formArrayName="items" cdkDropList (cdkDropListDropped)="onDrop($event)">
            @for (item of itemsArray.controls; let i = $index; track item) {
            <div [formGroup]="$any(item)" class="admin-row no-border-bottom quick-action-item" cdkDrag
                [cdkDragDisabled]="!item.get('isActive')?.value || !canDragItem(item.get('type')?.value)">

                <div class="drag-handle" cdkDragHandle>
                    <mat-icon class="admin-secondary" [class.disabled]="!canDragItem(item.get('type')?.value)">
                        {{ canDragItem(item.get('type')?.value) ? 'drag_indicator' : 'lock' }}
                    </mat-icon>
                </div>

                <div class="cell action-info">
                    <div class="admin-text">
                        {{ getActionDisplayName(item.get('type')?.value) }}
                    </div>
                    <div class="action-description">
                        {{ getActionDescription(item.get('type')?.value) }}
                        <div class="action-buttons">
                            <button mat-icon-button 
                                    color="accent"
                                    (click)="showDataSourceInfo(item.get('type')?.value)" 
                                    type="button"
                                    matTooltip="Datenquelle anzeigen"
                                    class="info-button">
                                <mat-icon>info</mat-icon>
                            </button>
                            @if (getConfigurationTab(item.get('type')?.value)) {
                                <button mat-icon-button 
                                        color="primary"
                                        (click)="navigateToConfiguration(item.get('type')?.value)" 
                                        type="button"
                                        matTooltip="Bearbeiten"
                                        class="edit-button">
                                    <mat-icon>edit</mat-icon>
                                </button>
                            }
                        </div>
                    </div>
                </div>

                <!-- Custom Label for specific actions -->
                @if (item.get('type')?.value === 'order' && item.get('isActive')?.value) {
                <mat-form-field appearance="outline" class="form-field-width cell">
                    <mat-label>Angepasster Text (optional)</mat-label>
                    <input matInput formControlName="label" placeholder="z.B. 'Blumen bestellen'">
                </mat-form-field>
                }

                <mat-slide-toggle formControlName="isActive" 
                                  class="cell"
                                  [disabled]="!hasRequiredData(item.get('type')?.value)"
                                  color="primary">
                </mat-slide-toggle>
            </div>
            <mat-divider></mat-divider>
            }
        </div>
        }
    </app-website-config-form-expansion-panel>
</div>